import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6 text-center text-customBlue">
        Terms and Conditions
      </h1>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-customBlue">
          Optom Shop Limited - CONDITIONS OF USE OF WEBSITE
        </h2>
        <p className="mb-4 text-gray-700">
          Your access to the Optom Shop Ltd website is deemed to constitute an
          agreement to the following conditions:
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-700">
          <li>
            Except to the extent required by law, Optom Shop Ltd accepts no
            liability for any direct or consequential loss or damage of any kind
            (including, without limitation, any loss of profits, business,
            goodwill or data) caused by or arising out of this site or any
            linked site or any information contained in such site. Any decisions
            based on information in this site are the sole responsibility of the
            visitor.
          </li>
          <li>
            Optom Shop Ltd makes all reasonable efforts to ensure that the
            content of this website is accurate at the time it was included and
            up to date. However, visitors should be aware that some information
            may be inaccurate, incomplete, or out of date, and you should not
            seek to rely on any information contained within this site without
            independently verifying its accuracy. Optom Shop reserves the right
            to make changes at any time, without prior notice.
          </li>
          <li>
            Optom Shop Ltd does not endorse or otherwise assume responsibility
            or liability for the content or operation of other websites linked
            to this website.
          </li>
          <li>
            This website (including these legal notices) shall be governed by
            the law of the United Kingdom.
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4 text-customBlue">
          Optom Shop Limited - CONDITIONS OF SALE
        </h2>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">1. DEFINITIONS</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>
              <strong>The Carrier:</strong> Any individual, company, or
              organisation carrying out delivery of the Goods.
            </li>
            <li>
              <strong>The Conditions:</strong> The terms and conditions of sale
              set out herein.
            </li>
            <li>
              <strong>The Contract:</strong> Any agreement for the purchase of
              Goods or Services.
            </li>
            <li>
              <strong>The Goods:</strong> Any equipment, parts, or material to
              be supplied by Optom Shop Ltd to the Purchaser.
            </li>
            <li>
              <strong>Product Literature:</strong> Any user operating or
              installation instructions supplied with the Goods.
            </li>
            <li>
              <strong>The Purchaser:</strong> The person, firm, institution,
              body, or company to whom Goods or Services are supplied subject to
              the Conditions.
            </li>
            <li>
              <strong>The Services:</strong> Services of any description
              provided by Optom Shop Ltd to the Purchaser.
            </li>
          </ul>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">2. GENERAL</h3>
          <p className="text-gray-700">
            Unless otherwise specifically agreed by Optom Shop Ltd in writing,
            the Conditions shall apply to all Contracts to the exclusion of all
            other terms and conditions including any terms or conditions which
            the Purchaser may purport to apply in any document issued by the
            Purchaser including but without limitation those contained in any
            order sent by the Purchaser. Acceptance of delivery of the Goods or
            commencement of the performance of the Services shall be deemed
            conclusive evidence of the Purchaser's acceptance of the Conditions.
            No particulars contained in any advertising matter, catalogues or
            other publication supplied by Optom Shop Ltd or any verbal
            representation by an employee or agent of Optom Shop Ltd shall form
            part of the Contract nor shall it be treated as constituting a
            representation on the part of Optom Shop Ltd.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">3. PRICES</h3>
          <p className="text-gray-700">
            The prices charged for the Goods shall be the Company's recommended
            list price less any applicable discount agreed by Optom Shop Ltd
            ruling at the date of acceptance by Optom Shop Ltd of the
            Purchaser's order. The price payable for the Services under the
            Contract shall be as stated in the quotation or tender sent by the
            Company and shall not be varied otherwise than by agreement in
            writing between the parties. All prices for Goods are quoted
            ex-works and unless specifically otherwise agreed in writing,
            delivery to the Purchaser's premises will be arranged by Optom Shop
            Ltd and the cost of delivery (including, but without limitation,
            carriage, packing, duty and insurance) will be arranged by Optom
            Shop Ltd. Where Goods are returned for repair out with the warranty
            period the Purchaser will be charged for the repair and any costs
            incurred in the collection from and delivery to the Purchaser's
            premises. Any query by the Purchaser of any invoice rendered by
            Optom Shop Ltd must be made in writing within 30 days of the date of
            that invoice otherwise the parties agree that such invoice shall be
            deemed accepted and the Purchaser's right to raise any query waived.
          </p>
          <p className="p-4 text-gray-700">
            <strong>3.1 </strong>The price payable for the goods ordered by the
            customer is as set out on the Optom Shop website at the time you
            place your order plus any charges for carriage and insurance as set
            out on the website.
          </p>
          <p className="p-4 text-gray-700">
            <strong>3.2 </strong>Optom Shop must receive payment for the whole
            of the price of the goods ordered, and any applicable charges for
            carriage, money transfer and insurance, before the customers order
            can be accepted.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">4. TERMS OF PAYMENT</h3>
          <p className="text-gray-700">
            Optom Shop must receive payment for the whole of the price of the
            goods ordered, and any applicable charges for carriage and
            insurance, before the customers order can be accepted. Payment can
            be made by cheque for the whole of the price of the goods ordered
            and made payable to Optom Shop Ltd. Payment can also be made during
            time of purchase through the company website{" "}
            <a href="www.optomshop.co.uk" className="text-blue-500 underline">
              www.optomshop.co.uk{" "}
            </a>
            using the payment processor company PayPal. Optom Shop Ltd will not
            be liable in any way for any direct or indirect loss, damage or
            expense (including loss of profits and liability to third parties)
            suffered by the Purchaser as a consequence of any issue with PayPal.
            Alternative arrangemements for payment with BACS money transfers can
            be made by contacting Optom Shop Ltd or see the payment methods
            page..
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">5. PROPERTY AND RISK</h3>
          <p className="text-gray-700">
            Property in the Goods will remain with Optom Shop Ltd until payment
            in full has been received by Optom Shop Ltd of all sums due,
            including interest where payable, in accordance with the Condition 4
            above. The Purchaser shall, while property in the Goods remains with
            Optom Shop Ltd pursuant to this Condition, hold the Goods on a
            fiduciary basis only and as a bailer only for the Company, keep the
            Goods separate from those of Optom Shop Ltd and third parties and
            property stores, protected and identified as Optom Shop Ltd’s
            property. The Purchaser may use or re-sell the Goods in the normal
            course of its business but until Optom Shop Ltd is paid in full the
            proceeds of any sale or insurance proceeds shall be held by the
            Purchaser in trust for Optom Shop Ltd and Optom Shop Ltd shall be
            entitled to trace all proceeds of sale in accordance with equitable
            principles.
          </p>
          <p className="pt-5 text-gray-700">
            Until such time as the property in the Goods passes to the
            Purchaser, the Purchaser grants to Optom Shop Ltd an irrevocable
            licence to enter the premises of the Purchaser to seize or remove
            any Goods not paid for in full at any time. Risk in the Goods shall
            pass to the Purchaser on delivery. Until Optom Shop Ltd has been
            paid in full for such Goods the Purchaser shall insure the goods to
            their full value against all risks and to the reasonable
            satisfaction of Optom Shop Ltd and shall immediately pay all
            proceeds received under such insurances to Optom Shop Ltd. All
            insurance claims will be pursued by the Purchaser as swiftly and
            efficiently as is practicable.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">6. DELIVERY</h3>
          <p className="text-gray-700">
            Unless otherwise agreed in writing between the parties, all
            deliveries by Optom Shop Ltd will be to the Purchaser's address as
            appears on Optom Shop Ltd records. If the address given to us is not
            accurate, and non-delivery results, then additional charges may be
            applied. The estimated delivery date will be as quoted on Optom Shop
            Ltd website or as otherwise notified by Optom Shop Ltd to the
            Purchaser. Free delivery is only available to mainland UK addresses,
            and any regions considered remote may incur a delivery surcharge, at
            the sole discretion of Optom Shop Limited.
          </p>
          <p className="pt-5 text-gray-700">
            Optom Shop Ltd will not be liable in any way for any direct or
            indirect loss, damage or expense (including loss of profits and
            liability to third parties) suffered by the Purchaser as a
            consequence of any delay in delivery or despatch of Goods or for
            delay in completion of any Services. Unless otherwise agreed in
            writing between the parties, Optom Shop Ltd shall be entitled to
            deliver the Goods by instalments and to tender a separate invoice
            for each instalment and to determine the route and manner of
            delivery of the Goods. Optom Shop Ltd shall be deemed to have the
            Purchaser's authority to make such contract with any Carrier as the
            Company may deem reasonable.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">
            7. CLAIMS FOR DEFECTS, DAMAGE, LOSS OR NON-DELIVERY
          </h3>
          <p className="text-gray-700">
            The Purchaser shall inspect all Goods on delivery and shall notify
            Optom Shop Ltd of any alleged defect in materials or workmanship,
            damage or failure to comply with description or sample or shortage
            in quantity in writing within three days of physical receipt and the
            Purchaser shall notify the Carrier within seven days of physical
            receipt. It is agreed that the Purchaser waives any claims he may
            otherwise have had where claims have not been made in writing within
            the aforesaid period. The packaging and contents must be retained
            and the Purchaser shall give Optom Shop Ltd an opportunity to
            inspect the Goods within a reasonable time following delivery before
            any use is made of them. Without prejudice to the foregoing the
            Purchaser must advise Optom Shop Ltd in writing, within seven days
            of the date of receipt of an invoice, of any non-delivery of entire
            batches of Goods. Notwithstanding the receipt by Optom Shop Ltd of
            any such notice a clear signature on a Carrier's delivery advice
            sheet shall be deemed to signify receipt of the quantity of cartons
            indicated thereon. If the Purchaser shall fail to comply with the
            foregoing the Goods shall be conclusively presumed to be in
            accordance with the Contract and free from any defect in materials
            or workmanship or damage which would be apparent on a reasonable
            examination of the Goods and the Purchaser shall be deemed to have
            accepted the Goods. If the Purchaser establishes to Optom Shop Ltd’s
            reasonable satisfaction that the Goods are not in accordance with
            the Contract or there is any defect in materials or workmanship, the
            Purchaser's sole remedy in respect thereof shall be limited as Optom
            Shop Ltd may elect, to making good any shortage, to replacing such
            Goods or refunding all, or part of, the Contract price against
            return of the Goods.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">8. FORCE MAJEURE</h3>
          <p className="text-gray-700">
            Optom Shop Ltd shall not be liable for failure to deliver the Goods
            or supply the Services for any reason whatsoever outside the
            reasonable control of Optom Shop Ltd including, without limitation
            to the generality of the foregoing, industrial action, war,
            governmental action, or regulation, act of God, riots or
            non-availability of stocks or materials and any delays by third
            party manufacturers in supplying any parts or materials. Any such
            failure shall not affect the obligation of the Purchaser to pay for
            Goods already delivered or Services already supplied.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">9. WARRANTY</h3>
          <p className="text-gray-700">
            Unless otherwise agreed by the parties in writing, the warranty on
            the Goods is as stated in the Product Literature, save that where no
            Product Literature is provided, Optom Shop Ltd warrants that it will
            provide, for the replacement or repair, at its option of defective
            materials and defective workmanship in the Goods (which would not
            have been apparent on a reasonable examination of the Goods on
            delivery) for a period of twelve months from the date of purchase.
            The standard RTB warranty will be invalidated in the event that a
            third party (other than a repair agent authorised by Optom Shop Ltd)
            or the Purchaser attempts repairs on the Goods. Optom Shop Ltd
            warrants that the Goods will be fit for any use attributed to them
            by good medical practice and not for any other use. Subject to the
            provision of this Condition 9 and any warranty and conditions
            contained in any product literature all warranties and conditions
            implied by statute or otherwise are hereby excluded PROVIDED THAT
            nothing herein shall affect the statutory rights of the Purchaser
            dealing as a consumer. Where the Goods are supplied in or to a
            country which is not a member state of the EEC, any warranties in
            respect of the Goods provided hereunder shall only apply in that
            country.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">10. RETURNS</h3>
          <p className="text-gray-700">
            Goods may only be returned to Optom Shop Ltd with the prior consent
            of Optom Shop Ltd and on terms to be determined at the absolute
            discretion of Optom Shop Ltd and must be securely packed with all
            original packaging and, unless the carrier effecting the return is
            instructed by Optom Shop Ltd, must be consigned carriage paid and
            fully insured. Goods returned without the prior written approval of
            Optom Shop Ltd may at Optom Shop Ltd’s absolute discretion be
            returned to the Purchaser or retained at the Purchaser's costs
            without prejudice to any rights or remedies Optom Shop Ltd may have.
            Once a return is approved by Optom Shop Ltd, the purchaser must
            return the item within 10 working days. Failure to comply may result
            in an admin/restocking fee to be charged at the absolute discretion
            of Optom Shop Ltd.
          </p>
          <p className="pt-5 text-gray-700">
            All returns must be accompanied by a completed return form:
          </p>
          <ul className="list-disc list-inside">
            <li>
              <a
                download
                href="/docs/Returns_Form.doc"
                className="text-blue-500 underline"
              >
                Download Returns Form (doc)
              </a>
            </li>
            <li>
              <a
                download
                href="/docs/Returns_Form.pdf"
                className="text-blue-500 underline"
              >
                Download Returns Form (PDF)
              </a>
            </li>
          </ul>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">
            11. EXCLUSION OF LIABILITY{" "}
          </h3>
          <p className="text-gray-700">
            Optom Shop Ltd shall not be liable for any loss, damage or expenses
            (whether direct, indirect, consequential or otherwise) suffered or
            incurred by the Purchaser arising out of the delivery, installation,
            sale, use or maintenance of the Goods and/or the provision of the
            Services except for any loss, damage or expenses arising from any
            defect in materials or workmanship in the Goods which would not have
            been apparent upon a reasonable inspection of the Goods upon
            delivery or any negligent act or omission or wilful default of Optom
            Shop Ltd save that where Optom Shop Ltd is liable for any loss,
            damage or expenses as aforesaid (a) Optom Shop Ltd’s liability shall
            be limited to £1 per claim and (b) Optom Shop Ltd shall not be
            liable for any consequential or indirect loss, damage or expenses
            suffered by the Purchaser (including but not limited to loss of
            profit, loss of goodwill, costs and expenses payable to third
            parties).
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">12. INDEMNITY</h3>
          <p className="text-gray-700">
            The Purchaser shall indemnify Optom Shop Ltd for all loss, damage
            and expenses (whether direct, indirect, consequential or otherwise)
            suffered or incurred by Optom Shop Ltd arising from the delivery,
            installation, use or maintenance of the Goods or provision of the
            Services whether by the Purchaser or any third party, save that the
            Purchaser shall not be required to indemnify Optom Shop Ltd if and
            to the extent that Optom Shop Ltd is liable under Condition 11.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">
            13. INTELLECTUAL PROPERTY RIGHTS
          </h3>
          <p className="text-gray-700">
            Optom Shop Ltd shall indemnify the Purchaser for and against any
            claim made or action brought in respect of infringement of patents,
            copyright, trade marks, trade names, registered designs or any other
            intellectual property rights in respect of the Goods, provided that
            the Purchaser shall have notified Optom Shop Ltd in the event of any
            claim or action being brought or threatened in this respect. Optom
            Shop Ltd shall be entitled to conduct all negotiations and take all
            necessary proceedings to dispute such a claim in its own name or in
            the name of the Purchaser or in both names but the conduct of
            proceedings and negotiations shall be completely at the discretion
            of Optom Shop Ltd. The Purchaser agrees to execute all such
            documents and do all such things and render all such assistance to
            Optom Shop Ltd as Optom Shop Ltd shall require. The Purchaser shall
            take all steps to ensure that it does not prejudice Optom Shop Ltd’s
            situation in this respect.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">14. SUB-CONTRACTS</h3>
          <p className="text-gray-700">
            Optom Shop Ltd expressly reserves the right to sub-contract the
            performance of any Contract for the supply of Goods or provision of
            Services or any part thereof.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">15. WARRANTY</h3>
          <p className="text-gray-700">
            Where installation is quoted as being included in the price of
            Goods, this will include only the sitting of the Goods in an
            appropriate place where all necessary services have been made
            available. Once installed and tested and shown to be operating to
            the satisfaction of Optom Shop Ltd, the Goods shall be deemed to
            have been accepted by the Purchaser unless Optom Shop Ltd is
            notified to the contrary by the Purchaser within seven days of
            completion of such testing in the event of a substantial defect in
            the Goods and Optom Shop Ltd shall have failed to have remedied such
            defect within a reasonable time of notification of the existence of
            such defect.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">
            16. DEFAULT BY THE BUYER
          </h3>
          <p className="text-gray-700">
            Sums outstanding in respect of any Goods or the performance of any
            Services shall become immediately payable if: (i) the Purchaser
            fails to make payment for the Goods in accordance with Condition 4
            or (ii) commits any other breach of the Contract, or (iii) if any
            distress or execution shall be levied upon any of the Purchaser's
            goods or if the Purchaser offers to make any arrangement with its
            creditors or commits an act of bankruptcy or if any petition in
            bankruptcy be presented against the Purchaser or the Purchaser is
            unable to pay its debts as they fall due or if being a limited
            company any resolution or petition to wind up the Purchaser (other
            than for the purpose of amalgamation or reconstruction without
            insolvency) shall be passed or presented or if a receiver,
            administrator, administrative receiver or manager shall be appointed
            over the whole or any part of the Purchaser's business or if the
            Purchaser shall suffer any analogous proceedings under foreign law
            or if the Purchaser ceases or threatens to cease to carry on
            business. In addition, Optom Shop Ltd may in its absolute discretion
            and without prejudice to any other rights which it may have: suspend
            all future deliveries of Goods to the Purchaser and/or supply of
            Services and/or terminate the Contract without liability upon its
            part, and/or exercise any of its rights pursuant to Condition 5.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">
            17. SET-OFF AND COUNTERCLAIM
          </h3>
          <p className="text-gray-700">
            The Purchaser shall not be entitled to withhold payment of any
            invoice by reason of any right of set off or counterclaim which the
            Purchaser may have or allege to have or for any other reason
            whatsoever.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">18. TRADEMARKS</h3>
          <p className="text-gray-700">
            Unless otherwise agreed in writing all Goods shall, if sold
            packaged, be sold or re-sold only in the packaging supplied by Optom
            Shop Ltd and in no case may any trade mark other than those applied
            by Optom Shop Ltd be marked on or applied in relation to the Goods.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">
            19. LAW AND JURISDICTION
          </h3>
          <p className="text-gray-700">
            These Conditions and the Contract shall be governed in all respects
            by the law of the United Kingdom.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">20. SEVERANCE</h3>
          <p className="text-gray-700">
            Any provision or term of these Conditions or of any Contract which
            is or may be void or unenforceable shall to the extent of such
            invalidity or unenforceability be deemed severable and shall not
            affect any other provision hereof.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">21. WAIVER</h3>
          <p className="text-gray-700">
            No waiver or forbearance by Optom Shop Ltd, whether express or
            implied, in enforcing any of its rights hereunder shall prejudice
            its right to do so in the future.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">22. ASSIGNMENT</h3>
          <p className="text-gray-700">
            The Purchaser may not assign, subcontract or in any way dispose of
            its rights or obligations under the Contract without the prior
            written consent of Optom Shop Ltd.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2 text-customBlue">23. EXPORT CONTRACTS</h3>
          <p>
            Where the Goods are supplied for export, from the United Kingdom,
            the provisions of this Condition shall subject to any special terms
            agreed between Optom Shop Ltd and the Purchaser apply
            notwithstanding any other provisions of these Conditions. The
            Purchaser shall be responsible for complying with any legislation or
            regulations governing the importation of the Goods into the country
            of destination and for the payment of any duties thereon.
          </p>
          <p className="pt-6 text-gray-700">
            The Purchaser shall be responsible for arranging for testing and
            inspection of the Goods at Optom Shop Ltd’s premises before
            shipment.
          </p>
          <p className="pt-6 text-gray-700">
          However, the Purchaser may elect, at its own cost, for Optom Shop Ltd to arrange for an independent third party to inspect the Goods at Optom Shop Ltd's premises before shipment and the Purchaser agrees to be bound by the decision of such third party. Optom Shop Ltd shall have no liability to any claim in respect of any defect in the Goods which would be apparent on inspection and which is made after shipment, or in respect of any damage during transit. For overseas deliveries insurance will be arranged for the Goods whilst in transit by Optom Shop Ltd  on behalf of the Purchaser and will be charged to the Purchaser together with the price of the Goods.
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
